import PropTypes from 'prop-types';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

const Default = (colors) => {
  const { red, gold, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  // Custom primary color palette - Black (#1E1E1E)

  const primaryColors = [
      '#F7EBF4', // lighter
      '#E3C0D9', // 100
      '#CF95BF', // 200
      '#BB6AA4', // light
      '#A44E8C', // 400
      '#8D3B77', // main
      '#7A3366', // dark
      '#672B56', // 700
      '#542346', // darker
      '#411B36'  // 900
   ];

      
   const secondaryColors = [
      '#F0F0F0', // lighter
      '#D4D4D4', // 100
      '#B8B8B8', // 200
      '#9C9C9C', // light
      '#818181', // 400
      '#676767', // main
      '#585858', // dark
      '#494949', // 700
      '#3A3A3A', // darker
      '#2B2B2B'  // 900
   ];

   const tertiaryColors = [
      '#FAF3F8', // lighter
      '#EDDEE8', // 100
      '#E1C9D8', // 200
      '#D4B4C8', // light
      '#CE9FC0', // 400
      '#D9A0CD', // main
      '#C18BB8', // dark
      '#A876A3', // 700
      '#8F618E', // darker
      '#764C79'  // 900
   ];


  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      main: secondaryColors[5],
      600: secondaryColors[6],
      dark: secondaryColors[7],
      800: secondaryColors[8],
      darker: secondaryColors[9],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: '#fff'
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: tertiaryColors[0],
      light: tertiaryColors[3],
      main: tertiaryColors[5],
      dark: tertiaryColors[7],
      darker: tertiaryColors[9],
      contrastText
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
};

Default.propTypes = {
  colors: PropTypes.object
};

export default Default;
